exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".studentExpectationsDisplay .dateSpanSelector .btn-group button{padding-left:0}.studentExpectationsDisplay .progressDisplay,.studentExpectationsDisplay .singleStat{display:inline-block;width:20%;vertical-align:top;margin-right:25px}.studentExpectationsDisplay .studentExpectationsDisplay .assignmentHeaderText{font-size:1.4em}.studentExpectationsDisplay .metric{font-size:1.4em;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/students/student_expectations_display.scss
// module id = 1432
// module chunks = 0